const GEOFENCE_FALLBACK_RADIUS = 200;
let lastSyncedHash = '';

const buildGeofencePayload = (office) => {
	const latitude = office?.address?.geometry?.lat;
	const longitude = office?.address?.geometry?.lng;
	if (latitude === undefined || longitude === undefined) return null;

	let radius = office?.geoFence?.radius;
	if (!radius || radius <= 0) {
		console.warn(`Office ${office._id} (${office.name}) is missing geofence radius, using fallback value of ${GEOFENCE_FALLBACK_RADIUS} meters.`);
		radius = GEOFENCE_FALLBACK_RADIUS;
	}

	return {
		officeId: office._id,
		officeName: office.name,
		latitude: latitude,
		longitude: longitude,
		radius: radius,
	};
};

const computeGeofenceHash = (payloads) => {
	return payloads
		.map((payload) => `${payload.officeId}:${payload.latitude}:${payload.longitude}:${payload.radius}`)
		.sort()
		.join('|');
};

const syncGeofenceOfficesToNative = (offices) => {
	if (!window?.ReactNativeWebView || !Array.isArray(offices) || offices.length === 0) return false;

	const geofenceOffices = offices
		.map((office) => buildGeofencePayload(office))
		.filter((payload) => payload !== null);

	if (geofenceOffices.length === 0) return false;

	const currentHash = computeGeofenceHash(geofenceOffices);
	if (currentHash === lastSyncedHash) return false;

	window.ReactNativeWebView.postMessage(
		JSON.stringify({
			geofenceOffices: geofenceOffices,
		}),
	);

	lastSyncedHash = currentHash;
	return true;
};

export {syncGeofenceOfficesToNative};
